



























import { Component, Vue } from 'vue-property-decorator';

@Component
export default class FooterBar extends Vue {
  navigation: any[] = [
    {
      to: '/terms-and-conditions',
      label: 'footer.navigation.terms-and-conditions',
    },
    {
      to: '/privacy',
      label: 'footer.navigation.privacy',
    },
    {
      to: '/settings/profile',
      label: 'footer.navigation.profile',
    },
  ];

  get year(): number {
    const now = new Date(Date.now());
    return now.getFullYear();
  }
}
